import Vue from "vue";
import firebase from "firebase";
import _ from "lodash";
import {
  createFindingPath,
  createAuditItemPath,
  createFindingMediaPath,
  errorIfFlase,
  fieldPath
} from "@/utils/firestorePathHelper";
import { CalcQkResult } from "@/utils/AuditResult";
import uuid from "uuid";
import { api as confApi } from "@/store/modules/configuration";

const setAudit = "setAudit";
const clearAudit = "clearAudit";
const changeAuditName = "changeAuditName";
const updateCompanyMetadata = "updateCompanyMetadata";
const createAudit = "createAudit";
const updateAuditMetadata = "updateAuditMetadata";

const SET_UNLISTENER = "SET_UNLISTENER";
const SET_DOCUMENT = "SET_DOCUMENT";
const SET_MEASURE_DOCUMENTS = "SET_MEASURE_DOCUMENTS";
const CLEAR_AUDIT = "CLEAR_AUDIT";

const getAuditDocumentData = "getAuditDocumentData";
const getAuditId = "getAuditId";
const getAuditStatus = "getAuditStatus";
const getAuditItems = "getAuditItems";
const getAuditCompanyMetadataDialogData = "getAuditCompanyMetadataDialogData";
const getAuditMetadataDialogData = "getAuditMetadataDialogData";
const getAuditReportSummary = "getAuditReportSummary";
const getScoreCalcSteps = "getScoreCalcSteps";
const getAuditProgress = "getAuditProgress";
const getFlatExportData = "getFlatExportData";
const getAuditStatistics = "getAuditStatistics";
const getAuditScore = "getAuditScore";
const getAuditFindingsFlat = "getAuditFindingsFlat";
const getFlatAuditScoreData = "getFlatAuditScoreData";
const getAuditReportCalcSchema = "getAuditReportCalcSchema";
const getDefaultCalcSchemaName = "getDefaultCalcSchemaName";

const isExistingDocument = "isExistingDocument";
const hasPendingWrites = "hasPendingWrites";
const isCachedDocument = "isCachedDocument";
const getDocumentOnlineState = "getDocumentOnlineState";

const reactivateAuditItem = "reactivateAuditItem";
const storeFinding = "storeFinding";
const deleteDeviation = "deleteDeviation";
const attachFileToFinding = "attachFileToFinding";
const updateFindingAttachment = "updateFindingAttachment";
const customAuditResult = "customAuditResult";

const Document = "Document";
const Unlistener = "Unlistener";

const MeasureDocuments = "MeasureDocuments";
const MeasureUnlistener = "MeasureUnlistener";

const COLLECTION_NAME = "audits";

const isUnDef = v => {
  return typeof v === "undefined";
};
const getFallback = (v, alt) => {
  return isUnDef(v) ? alt : v;
};

const calc_deviation = (
  findings_range_min,
  findings_range_max,
  findings_config
) => {
  const config_from_id = importance => {
    const default_config = { value: findings_range_min };
    if (importance in findings_config) {
      return findings_config[importance] || default_config;
    } else {
      return default_config;
    }
  };
  const get_appreciable_finding_value = values => {
    return _.reduce(
      values,
      (prev, value) => {
        return Math.max(prev, value);
      },
      findings_range_min
    );
  };
  return {
    worst_finding_value: findings_range_max,
    best_finding_value: findings_range_min,
    findings_aggregator(start, current) {
      const importance =
        "importance" in current
          ? parseInt(config_from_id(current.importance).value, 10)
          : findings_range_min;
      return Math.max(start, importance);
    },
    config_from_id: config_from_id,
    get_appreciable_finding_value
  };
};

const calc_compliance = (
  findings_range_min,
  findings_range_max,
  findings_config
) => {
  const config_from_id = importance => {
    const default_config = { value: findings_range_max };
    if (importance in findings_config) {
      return findings_config[importance] || default_config;
    } else {
      return default_config;
    }
  };
  const get_appreciable_finding_value = values => {
    return _.reduce(
      values,
      (prev, value) => {
        return Math.min(prev, value);
      },
      findings_range_max
    );
  };

  return {
    worst_finding_value: findings_range_min,
    best_finding_value: findings_range_max,
    findings_aggregator(start, current) {
      const importance =
        "importance" in current
          ? parseInt(config_from_id(current.importance).value, 10)
          : findings_range_max;
      return Math.min(start, importance);
    },
    config_from_id: config_from_id,
    get_appreciable_finding_value
  };
}; /*
const get_best_fit = (values, value) => {
  let best_delta = Number.MAX_SAFE_INTEGER;

  return values.reduce((initial, fit_value) => {
    const current_delta = Math.abs(value - fit_value);
    if (current_delta < best_delta) {
      best_delta = current_delta;
      return fit_value;
    } else {
      return initial;
    }
  }, value);
};
*/
const audit_item_weight = (WeightId, rootState) => {
  const importance = rootState.configuration.audititem.data.importance.find(
    item => item.id == WeightId
  );
  console.assert(
    typeof importance !== "undefined",
    "Expect",
    WeightId,
    "is an known importance Id in ",
    rootState.configuration.audititem.data.importance
  );
  let weight = 0;
  if (typeof importance === "undefined") {
    weight = parseInt(WeightId, 10);
  } else {
    weight = parseInt(importance.value, 10);
  }

  console.assert(!isNaN(weight), "Expect is not NaN", WeightId);
  if (isNaN(weight)) {
    return 0;
  } else {
    return weight;
  }
};

const default_flat_export_row = (AuditItem, DefaultFindingOrder, category) => {
  return {
    auditItemId: AuditItem.id,
    auditItemCategory: AuditItem.question.category,
    auditItemCategoryName: category
      ? category.name
      : AuditItem.question.category,
    auditItemWeight: AuditItem.Weight || 0,
    auditItemText: AuditItem.question.text,
    findingOrder: DefaultFindingOrder,
    findingId: null,
    findingNote: null,
    findingWeight: null,
    findingTypeId: null,
    findingTypeName: null,
    findingTypeAbbr: null,
    findingTypeDesc: null,
    findingWeightBestPossible: null,
    findingWeightWorstPossible: null,
    measureId: null,
    measureNote: null,
    measureDesc: null,
    measureTypeId: null,
    measureTypeAbbr: null,
    measureTypeName: null,
    measureTypeDesc: null,

    measureCauseAnalysis: null,
    measureDueDate: null,
    measureDueDateLocale: "",
    measureAssignedTo: null,
    measureCreateDate: null,
    measureCreateDateLocale: "",
    measureAuthor: null,
    measureStatus: null,
    measurePriority: null
  };
};

const normalize_measure_for_flat_export = (
  Measure,
  MeasureTypesConfig,
  UserGetter
) => {
  const MeasureTypeConfig = MeasureTypesConfig.find(MeasureType => {
    return (Measure.measuretype || "0") == MeasureType.id;
  });

  const user_name_from_id = Id => {
    const user = UserGetter(Id);
    if (user) {
      return [user.displayName, "<" + user.email + ">"];
    } else {
      return [Id];
    }
  };

  const dueDate = new Date(Measure.dueDate);
  const createdDate = new Date(Measure.createdDate);
  return {
    measureId: Measure.id,
    measureNote: Measure.text,
    measureDesc: Measure.description,
    measureTypeId: Measure.measuretype,
    measureTypeAbbr: MeasureTypeConfig.short,
    measureTypeName: MeasureTypeConfig.text,
    measureTypeDesc: MeasureTypeConfig.description,
    measureCauseAnalysis: Measure.cause_analysis,
    measureDueDate: dueDate,
    measureDueDateLocale: dueDate.toLocaleDateString(),
    measureAssignedTo: user_name_from_id(Measure.assignedTo)[0],
    measureAssignedToAndMail: user_name_from_id(Measure.assignedTo).join(" "),
    measureCreateDate: createdDate,
    measureCreateDateLocale: createdDate.toLocaleDateString(),
    measureAuthor: user_name_from_id(Measure.autor)[0],
    measureAuthorAndMail: user_name_from_id(Measure.autor).join(" "),
    measureStatus: Measure.status,
    measurePriority: Measure.priority
  };
};

const getFindingType = (FindingTypeId, rootState) => {
  const finding_type = rootState.configuration.finding.data.importance.find(
    item => item.id == FindingTypeId
  );
  console.assert(
    typeof finding_type !== "undefined",
    "Expect",
    FindingTypeId,
    "is an known importance Id in ",
    rootState.configuration.finding.data.importance
  );
  return finding_type || null;
};

const getFindingTypeWeight = FindingType => {
  if (FindingType) {
    const weight = parseInt(FindingType.value, 10);
    console.assert(!isNaN(weight), "Expect is not NaN", FindingType);
    if (isNaN(weight)) {
      return null;
    } else {
      return weight;
    }
  } else {
    return null;
  }
};

const auditItemCountByType = (audit_items, audit_item_types) => {
  return Object.entries(
    Object.values(audit_items)
      .map(audit_item => {
        return String(audit_item.question.importance);
      })
      .reduce((prev, id) => {
        if (id in prev) {
          prev[id] += 1;
        } else {
          prev[id] = 1;
        }
        return prev;
      }, {})
  )
    .map(([id, count]) => {
      const type = audit_item_types.find(type => type.id === id);

      return {
        count,
        id,
        value: type ? type.value : 0,
        name: type ? type.description : 0
      };
    })
    .sort((lhs, rhs) => {
      return rhs.value - lhs.value;
    });
};

const auditFindingsCountByType = (
  audit_items,
  finding_types,
  findings_order
) => {
  const findings = Object.values(audit_items).reduce((prev, audit_item) => {
    const findings = Object.values(audit_item.deviations || {}).map(finding => {
      const finding_type_id = getFindingTypeId(finding);
      console.assert(finding_type_id, "Unknown finding type", finding);
      return String(finding_type_id);
    });
    prev.push(...findings);
    return prev;
  }, []);

  return Object.entries(
    findings.reduce((prev, id) => {
      if (id in prev) {
        prev[id] += 1;
      } else {
        prev[id] = 1;
      }
      return prev;
    }, {})
  )
    .map(([id, count]) => {
      const type = finding_types.find(type => type.id === id);
      console.assert(type, `Unknown finding type "${id}"`, finding_types);
      return {
        count,
        id,
        value: type ? type.value : 0,
        name: type ? type.text : "",
        is_no_deviation: type.is_no_deviation || false,
        is_not_applicable: type.is_not_applicable || false
      };
    })
    .sort((lhs, rhs) => {
      return (
        findings_order.findIndex(val => val === lhs.id) -
        findings_order.findIndex(val => val === rhs.id)
      );
    });
};

const auditMeasuresCountByType = (measures, measure_types) => {
  return Object.entries(
    measures
      .map(measure => String(measure.measuretype || ""))
      .reduce((prev, id) => {
        if (id in prev) {
          prev[id] += 1;
        } else {
          prev[id] = 1;
        }
        return prev;
      }, {})
  )
    .map(([id, count]) => {
      const type = measure_types.find(type => type.id === id);

      return {
        count,
        id,
        name: type ? type.text : 0
      };
    })
    .sort((lhs, rhs) => {
      return (
        measure_types.findIndex(val => val.id === lhs.id) -
        measure_types.findIndex(val => val.id === rhs.id)
      );
    });
};

const getFindingTypeId = Finding => {
  const finding_type_id =
    typeof Finding.importance === "undefined"
      ? Finding.id || null
      : Finding.importance;
  console.assert(
    finding_type_id !== null,
    "Fail to extract finding type id",
    Finding
  );
  return finding_type_id;
};

export const api = {
  namespace: "audit",
  actions: {
    setAudit,
    clearAudit,
    changeAuditName,
    updateCompanyMetadata,
    createAudit,
    updateAuditMetadata,
    reactivateAuditItem,
    storeFinding,

    deleteDeviation,
    attachFileToFinding,
    updateFindingAttachment
  },
  mutations: {
    SET_UNLISTENER,
    SET_DOCUMENT,
    SET_MEASURE_DOCUMENTS,
    CLEAR_AUDIT
  },
  getters: {
    getAuditDocumentData,
    getAuditId,
    getAuditStatus,
    getAuditItems,
    getAuditCompanyMetadataDialogData,
    getAuditMetadataDialogData,
    getAuditReportSummary,
    getScoreCalcSteps,
    getAuditProgress,
    getFlatExportData,
    getAuditStatistics,
    getAuditScore,
    getAuditFindingsFlat,
    getFlatAuditScoreData,
    getAuditReportCalcSchema,
    getDefaultCalcSchemaName,

    isExistingDocument,
    hasPendingWrites,
    isCachedDocument,
    getDocumentOnlineState,
    customAuditResult
  },
  state: {
    Document,
    Unlistener,
    MeasureDocuments,
    MeasureUnlistener
  }
};
/*context = {
    state, // same as `store.state`, or local state if in modules
    rootState, // same as `store.state`, only in modules
    commit, // same as `store.commit`
    dispatch, // same as `store.dispatch`
    getters, // same as `store.getters`, or local getters if in modules
    rootGetters // same as `store.getters`, only in modules
  }*/

function createAuditObserver(context, auditId) {
  const observer = {
    error(error) {
      console.error(`AuditObserver(${auditId}).complete`, error);
    },
    next(snapshot) {
      const data = snapshot.data() || null;
      if (typeof data.reportSchema !== "string") {
        data.reportSchema = context.getters.getDefaultCalcSchemaName;
      }
      data.id = snapshot.id;

      context.commit(api.mutations.SET_DOCUMENT, {
        data,
        metadata: {
          ...snapshot.metadata
        },
        exists: snapshot.exists,
        id: snapshot.id
      });
    }
  };
  return firebase
    .firestore()
    .collection(COLLECTION_NAME)
    .doc(auditId)
    .onSnapshot({ includeMetadataChanges: true }, observer);
}

function createMeasuresObserver(context, auditId) {
  const observer = {
    error(error) {
      console.error(`MeasuresObserver(${auditId}).complete`, error);
    },
    next(querySnapshot) {
      const measureDocs = querySnapshot.docChanges();
      const removeMeasures = measureDocs
        .filter(docChange => docChange.type === "removed")
        .map(docChange => docChange.doc.id);

      const modifiedMeasures = measureDocs
        .filter(docChange => docChange.type !== "removed")
        .map(docChange => {
          const doc = docChange.doc;
          return {
            data: doc.data(),
            metadata: {
              ...doc.metadata
            },
            exists: doc.exists,
            id: doc.id
          };
        });

      context.commit(api.mutations.SET_MEASURE_DOCUMENTS, {
        removeMeasures,
        modifiedMeasures
      });
    }
  };
  console.log(observer, auditId); // Todo: Use current measures in audit instead of measures in auditS
  return null;
  /*
  return firebase
    .firestore()
    .collection("measures")
    .where("audit_id", "==", auditId)
    .onSnapshot(observer); */
}

const actions = {
  [api.actions.setAudit](context, AuditId) {
    context.commit(api.mutations.SET_UNLISTENER, {
      auditUnlistener: createAuditObserver(context, AuditId),
      measuresUnlistener: createMeasuresObserver(context, AuditId)
    });
  },

  [api.actions.clearAudit](context) {
    context.commit(api.mutations.CLEAR_AUDIT);
  },

  [api.actions.changeAuditName](context, AuditName) {
    const auditId = context.getters.getAuditId;

    if (auditId) {
      return firebase
        .firestore()
        .collection(COLLECTION_NAME)
        .doc(auditId)
        .update({
          name: AuditName
        });
    } else {
      throw "no-audit-active";
    }
  },
  [api.actions.updateCompanyMetadata](
    context,
    { AuditId, CompanyMetadataUpdateData }
  ) {
    if (AuditId) {
      return firebase
        .firestore()
        .collection(COLLECTION_NAME)
        .doc(AuditId)
        .update({
          companyMetadata: CompanyMetadataUpdateData
        });
    } else {
      throw "no-audit-active";
    }
  },
  [api.actions.createAudit]({ dispatch }, { data, activity }) {
    const collection = firebase.firestore().collection(COLLECTION_NAME);
    const docRef = collection.doc();
    docRef
      .set(data)
      .then(() => {
        if (activity) {
          dispatch("activities/createActivity", activity(docRef.id, true), {
            root: true
          });
        }
      })
      .catch(err => console.error("Create Audit failed: ", err));

    return docRef;
  },
  [api.actions.updateAuditMetadata]({ dispatch }, { id, data, activity }) {
    data = _.cloneDeep(data);
    delete data.hasPendingWrites;
    delete data.fromCache;
    delete data.workflow;
    delete data.companyMetadata;
    delete data.audit_items;
    delete data.members;
    delete data.additionalReportData;
    delete data.exists;
    delete data.id;

    if (id) {
      if (activity) {
        dispatch("activities/createActivity", activity, { root: true });
      }
      return firebase
        .firestore()
        .collection(COLLECTION_NAME)
        .doc(id)
        .update(data);
    } else {
      throw "no-audit-active";
    }
  },
  async [api.actions.reactivateAuditItem](
    { getters },
    { ref: { auditId, auditItemId, findingId } }
  ) {
    errorIfFlase(
      auditId === getters[api.getters.getAuditId],
      "Expect reactivateAuditItem is called on current audit"
    );
    errorIfFlase(
      auditItemId in getters[api.getters.getAuditItems],
      "expect auditItemId exists in current audit"
    );

    const auditItem = getters[api.getters.getAuditItems][auditItemId];
    let currentAuditItemState = auditItem.auditItemState;
    if (!currentAuditItemState) {
      for (const val of ["deactivated", "completed"]) {
        if (auditItem[val]) {
          currentAuditItemState = val;
          break;
        }
      }
    }
    errorIfFlase(
      typeof currentAuditItemState === "string",
      "expect audititem is deactivated"
    );

    const auditItemBased = (...parts) => {
      return fieldPath("audit_items", auditItemId, ...parts);
    };

    const firebaseUpdatedata = {};

    firebaseUpdatedata[auditItemBased("auditItemState")] = null;
    firebaseUpdatedata[auditItemBased(currentAuditItemState)] = false;
    firebaseUpdatedata[
      auditItemBased("deviations", findingId)
    ] = firebase.firestore.FieldValue.delete();

    console.log("reactivateAuditItem", firebaseUpdatedata);

    const { ref, doc } = createAuditItemPath(auditId, auditItemId);

    firebase
      .firestore()
      .collection(ref)
      .doc(doc)
      .update(firebaseUpdatedata)
      .then(() => {
        console.log("audititem reactivation stored in the Backend");
      });
  },

  async [api.actions.storeFinding](
    { getters, rootGetters },
    {
      ref: { auditId, auditItemId, findingId },
      data,
      writeType // update, create
    }
  ) {
    errorIfFlase(
      auditId === getters[api.getters.getAuditId],
      "Expect create is called on current audit"
    );
    errorIfFlase(
      auditItemId in getters[api.getters.getAuditItems],
      "expect auditItemId exists in current audit"
    );

    const deviations =
      getters[api.getters.getAuditItems][auditItemId]["deviations"];
    if (writeType === "create") {
      findingId = uuid.v4();

      errorIfFlase(
        !(deviations instanceof Object && findingId in deviations),
        "expect finding doesn't exists in current audit"
      );
    } else {
      errorIfFlase(
        deviations instanceof Object && findingId in deviations,
        "expect finding exists in current audit"
      );
    }

    const deviation = {
      ...data
    };

    const findingType = rootGetters[
      [confApi.namespace, confApi.getters.getFindingTypes].join("/")
    ].find(val => val.id === deviation.importance);
    console.log("FindingType", findingType, deviation, data);

    errorIfFlase(findingType, "Unknown finding type");

    if (typeof deviation.text !== "string") {
      deviation.text =
        findingType.placeholder_text || "Das ist ein Platzhalter";
    }

    const auditItem = getters[api.getters.getAuditItems][auditItemId];
    let currentAuditItemState = auditItem.auditItemState;
    if (!currentAuditItemState) {
      for (const val of ["deactivated", "completed"]) {
        if (auditItem[val]) {
          currentAuditItemState = val;
          break;
        }
      }
    }

    /* Check in special finding Type */
    if (
      typeof findingType.auditItemState === "string" &&
      currentAuditItemState !== findingType.auditItemState &&
      deviations &&
      Object.values(deviations).length &&
      !confirm(
        "Alle anderen Feststellungen und Maßnahmen welche dieser Frage zugeordnet sind werden verworfen.\nWollen Sie die Frage abschließen?"
      )
    ) {
      return null;
    }

    const auditItemBased = (...parts) => {
      return fieldPath("audit_items", auditItemId, ...parts);
    };

    const firebaseUpdatedata = {};

    if (typeof findingType.auditItemState === "string") {
      firebaseUpdatedata[auditItemBased("auditItemState")] =
        findingType.auditItemState;
      firebaseUpdatedata[auditItemBased(findingType.auditItemState)] = true;

      firebaseUpdatedata[auditItemBased("deviations")] = {
        [findingId]: deviation
      };
    } else {
      if (currentAuditItemState) {
        firebaseUpdatedata[auditItemBased(currentAuditItemState)] = false;
      }
      firebaseUpdatedata[auditItemBased("auditItemState")] = null;

      firebaseUpdatedata[auditItemBased("deviations", findingId)] = deviation;
    }

    // delete deviation.media; // Media wird nachträglich gesetzt wenn das Finding existiert

    console.log(
      "storeFinding",
      findingType,
      data,
      firebaseUpdatedata,
      deviations
    );

    const { ref, doc } = createFindingPath(auditId, auditItemId, findingId);

    firebase
      .firestore()
      .collection(ref)
      .doc(doc)
      .update(firebaseUpdatedata)
      .then(() => {
        console.log("storeFinding stored in the Backend");
      });
    /*
      const batch = firebase.firestore().batch();

    const measures = await firebase
      .firestore()
      .collection("measures")
      .where("audititem_id", "==", audititem_id)
      .get();

    measures.forEach(doc => {
      batch.delete(doc.ref);
    });

    await batch.commit();*/

    return findingId;
  },
  async [api.actions.deleteDeviation](
    { getters },
    { ref: { auditId, auditItemId, findingId } }
  ) {
    errorIfFlase(
      auditId === getters[api.getters.getAuditId],
      "Expect create is called on current audit"
    );
    errorIfFlase(
      auditItemId in getters[api.getters.getAuditItems],
      "expect auditItemId exists in current audit"
    );

    const deviations =
      getters[api.getters.getAuditItems][auditItemId]["deviations"];

    errorIfFlase(
      deviations instanceof Object && findingId in deviations,
      "expect finding exists in current audit"
    );

    const auditItem = getters[api.getters.getAuditItems][auditItemId];
    let currentAuditItemState = auditItem.auditItemState;
    if (!currentAuditItemState) {
      for (const val of ["deactivated", "completed"]) {
        if (auditItem[val]) {
          currentAuditItemState = val;
          break;
        }
      }
    }
    const auditItemBased = (...parts) => {
      return fieldPath("audit_items", auditItemId, ...parts);
    };

    const { ref, doc, child } = createFindingPath(
      auditId,
      auditItemId,
      findingId
    );

    const firebaseUpdatedata = {
      [child]: firebase.firestore.FieldValue.delete()
    };
    if (currentAuditItemState) {
      firebaseUpdatedata[auditItemBased("auditItemState")] = null;
      firebaseUpdatedata[auditItemBased(currentAuditItemState)] = false;
    }

    console.log("deleteDeviation", firebaseUpdatedata);

    firebase
      .firestore()
      .collection(ref)
      .doc(doc)
      .update(firebaseUpdatedata)
      .then(() => {
        console.log("deleteDeviation stored in the Backend");
      });
  },
  async [api.actions.updateFindingAttachment](
    context,
    {
      ref: { auditId, auditItemId, findingId, mediaId },
      data: { url, dataUrl }
    }
  ) {
    const storageRef = firebase.storage().refFromURL(url);
    const oldMetadata = await storageRef.getMetadata();
    const customMetadata = oldMetadata.customMetadata;
    console.log(
      "updateFindingAttachment",
      customMetadata,
      auditId,
      auditItemId,
      findingId,
      mediaId
    );

    const uploadTask = await storageRef.putString(dataUrl, "data_url", {
      customMetadata
    });
    const newDownloadUrl = await uploadTask.ref.getDownloadURL();

    const { ref, doc, child } = createFindingMediaPath(
      customMetadata.auditId || auditId,
      customMetadata.auditItemId || auditItemId,
      customMetadata.findingId || findingId,
      mediaId
    );

    const firebaseUpdatedata = {
      [child]: { url: newDownloadUrl }
    };

    firebase
      .firestore()
      .collection(ref)
      .doc(doc)
      .update(firebaseUpdatedata)
      .then(() => {
        console.log("attachFileToFinding stored in the Backend");
      });
    return newDownloadUrl;
  },
  async [api.actions.attachFileToFinding](
    { dispatch },
    { audit_id, audititem_id, deviation_id, media_id, data: { url } }
  ) {
    dispatch("app/setLoading", true, { root: true });
    media_id = media_id || uuid.v4();

    const { ref, doc, child } = createFindingMediaPath(
      audit_id,
      audititem_id,
      deviation_id,
      media_id
    );

    const firebaseUpdatedata = {
      [child]: { url }
    };

    console.log("attachFileToFinding", firebaseUpdatedata);

    firebase
      .firestore()
      .collection(ref)
      .doc(doc)
      .update(firebaseUpdatedata)
      .then(() => {
        console.log("attachFileToFinding stored in the Backend");
      });
    dispatch("app/setLoading", false, { root: true });
  }
};

const mutations = {
  [api.mutations.SET_DOCUMENT](state, payload) {
    const currentDoc = state[api.state.Document];
    if (currentDoc && currentDoc.id === payload.id) {
      currentDoc.data = payload.data;
      currentDoc.metadata = payload.metadata;
      currentDoc.exists = payload.exists;
      // Vue.set(state, api.state.Document, payload);
    } else {
      Vue.set(state, api.state.Document, payload);
    }
  },
  [api.mutations.SET_MEASURE_DOCUMENTS](
    state,
    { removeMeasures, modifiedMeasures }
  ) {
    removeMeasures.forEach(measureId => {
      Vue.delete(state[api.state.MeasureDocuments], measureId);
    });

    if (state[api.state.MeasureDocuments] === null) {
      state[api.state.MeasureDocuments] = {};
    }
    modifiedMeasures.forEach(measureDoc => {
      Vue.set(state[api.state.MeasureDocuments], measureDoc.id, measureDoc);
    });
  },

  [api.mutations.SET_UNLISTENER](
    state,
    { auditUnlistener, measuresUnlistener }
  ) {
    const prevAuditUnlistener = state[api.state.Unlistener];
    const prevMeasureUnlistener = state[api.state.MeasureUnlistener];
    Vue.set(state, api.state.Unlistener, auditUnlistener);
    Vue.set(state, api.state.MeasureUnlistener, measuresUnlistener);
    if (prevAuditUnlistener) {
      prevAuditUnlistener();
    }
    if (prevMeasureUnlistener) {
      prevMeasureUnlistener();
    }
  },
  [api.mutations.CLEAR_AUDIT](state) {
    const prevAuditUnlistener = state[api.state.Unlistener];
    const prevMeasureUnlistener = state[api.state.MeasureUnlistener];
    Vue.set(state, api.state.Unlistener, null);
    Vue.set(state, api.state.Document, null);
    Vue.set(state, api.state.MeasureUnlistener, null);
    Vue.set(state, api.state.MeasureDocuments, {});

    if (prevAuditUnlistener) {
      prevAuditUnlistener();
    }

    if (prevMeasureUnlistener) {
      prevMeasureUnlistener();
    }
  }
};
const getters = {
  [api.getters.getAuditDocumentData](state) {
    const Document = state.Document;
    if (Document && Document.data) {
      return { ...Document.data };
    } else {
      return null;
    }
  },
  [api.getters.getAuditId](state) {
    const Document = state.Document;
    if (Document && Document.id) {
      return Document.id;
    } else {
      return null;
    }
  },
  [api.getters.getAuditStatus](state, getters) {
    const Document = getters.getAuditDocumentData;
    if (Document && "workflow" in Document && "status" in Document.workflow) {
      return Document.workflow.status;
    } else {
      return null;
    }
  },
  [api.getters.getAuditItems](state, getters) {
    const Document = getters.getAuditDocumentData;
    if (Document && "audit_items" in Document) {
      return Document.audit_items;
    } else {
      return {};
    }
  },

  [api.getters.getAuditCompanyMetadataDialogData](state) {
    const Document = state.Document;
    if (Document && Document.data) {
      return {
        id: Document.id,
        companyMetadata: Document.data.companyMetadata
      };
    } else {
      return null;
    }
  },
  [api.getters.getAuditMetadataDialogData](state) {
    const Document = state.Document;
    if (Document && Document.data) {
      return {
        id: Document.id,
        metadata: Document.data
      };
    } else {
      return null;
    }
  },

  [api.getters.getAuditReportSummary](state, getters, rootState) {
    const active_audit = getters.getAuditDocumentData;
    if (active_audit) {
      const defaultUserSkeleton = userId => {
        return {
          id: userId,
          email: "",
          displayName: "UserRef (" + userId + ") unresolved",
          firebase_id: null
        };
      };
      const scoreToComplianceScore = score => {
        const total_range = score.best - score.worst;
        const current_range = score.current - score.worst;
        const compliance = Math.round((current_range / total_range) * 100);
        return compliance;
      };
      const loaded_users = rootState.users.loadedUsers;

      const resolveUserFromId = userId => {
        if (userId) {
          console.assert(
            typeof userId === "string",
            "Expect type string found",
            typeof userId,
            "for",
            userId
          );
          const user = loaded_users.find(user => user.id === userId);
          if (user) {
            return user;
          } else {
            return defaultUserSkeleton(userId);
          }
        } else {
          return null;
        }
      };

      const toDateOr = (IsoDateString, Fallback) => {
        Fallback = Fallback || null;
        if (
          typeof IsoDateString === "string" &&
          /^\d{4}-\d{2}-\d{2}/.test(IsoDateString)
        ) {
          return new Date(IsoDateString.substr(0, 10));
        }
        return Fallback;
      };

      const score = getters.getAuditScore;
      return {
        leadAuditor: resolveUserFromId(
          getFallback(active_audit.leadauditor, null)
        ),
        responsibleUser: resolveUserFromId(
          getFallback(active_audit.responsible, null)
        ),
        auditReportingType: active_audit.reportSchema,
        auditId: getters.getAuditId,
        auditName: active_audit.name,
        auditPlaningDate: toDateOr(active_audit.planning_date, null),
        auditPlaningYear: active_audit.planning_year,
        auditingDates: _.map(active_audit.auditing_date, date => {
          return toDateOr(date, null);
        }),
        auditStandard: active_audit.standard,
        auditType: active_audit.type,
        auditWorkFlow: active_audit.workflow,
        auditParticipants: _.map(
          active_audit.audit_participants,
          resolveUserFromId
        ),
        auditCoAuditors: _.map(active_audit.coauditors, resolveUserFromId),
        auditedBy: active_audit.audited_by,
        auditSummary: getFallback(active_audit.summary, ""),
        statistics: getters.getAuditStatistics,
        score,
        compliancePercent: scoreToComplianceScore(score.inTotal)
      };
    } else {
      return null;
    }
  },
  [api.getters.getScoreCalcSteps](state, getters, rootState, rootGetters) {
    const aggregate_score_data = audit_score_data => {
      const bestScore = audit_score_data.reduce(
        (prev, criteria) => prev + criteria.bestScore,
        0
      );
      const criteriaNotApplicabelTotalScore = audit_score_data.reduce(
        (prev, criteria) =>
          prev + (criteria.isNotApplicable ? criteria.bestScore : 0),
        0
      );
      const currentScore = audit_score_data.reduce(
        (prev, criteria) => prev + criteria.currentScore,
        0
      );
      const worstScore = audit_score_data.reduce(
        (prev, criteria) => prev + criteria.worstScore,
        0
      );
      const newBestScore = bestScore - criteriaNotApplicabelTotalScore;
      const compliancePercent =
        (currentScore - worstScore) / (newBestScore - worstScore);

      return {
        customResult: getters[api.getters.customAuditResult],
        compliancePercent,
        criteriaTotalCount: audit_score_data.length,
        bestScore,
        worstScore,
        currentScore,

        criteriaNotApplicabelTotalCount: audit_score_data.reduce(
          (prev, criteria) => prev + (criteria.isNotApplicable ? 1 : 0),
          0
        ),
        criteriaNotApplicabelTotalScore,

        criteriaUnanswerdTotalCount: audit_score_data.reduce(
          (prev, criteria) => prev + (criteria.findingsCount === 0 ? 1 : 0),
          0
        ),
        criteriaUnanswerdTotalScore: audit_score_data.reduce(
          (prev, criteria) =>
            prev + (criteria.findingsCount === 0 ? criteria.bestScore : 0),
          0
        ),

        // TODO: Falschaussage, da dort auch OK Bemerkungen drin liegen
        deviationsTotalCount: audit_score_data.reduce(
          (prev, criteria) => prev + criteria.deviationCount,
          0
        )
      };
    };

    const audit_score_data = getters.getFlatAuditScoreData;

    const auditStandards =
      getters.getAuditDocumentData && getters.getAuditDocumentData.standard
        ? getters.getAuditDocumentData.standard
        : [];

    let auditCategories = _.filter(
      rootGetters["configuration/categories"],
      (v, i) => {
        return auditStandards.findIndex(s => s == i) >= 0;
      }
    );

    const categoryById = Id => {
      return auditCategories.reduce((p, c) => {
        if (p === null) {
          const cat = c.find(v => v.id == Id);
          if (cat) {
            return cat;
          }
        } else {
          return p;
        }
      }, null);
    };

    const result = aggregate_score_data(audit_score_data);

    const grouped = Object.entries(
      audit_score_data.reduce((prev, item) => {
        if (item.auditItemCategoryId in prev) {
          prev[item.auditItemCategoryId].push(item);
        } else {
          prev[item.auditItemCategoryId] = [item];
        }
        return prev;
      }, {})
    ).map(([auditItemCategoryId, items]) => {
      const by_category = aggregate_score_data(items);
      const c = categoryById(auditItemCategoryId);

      by_category.auditItemCategoryId = auditItemCategoryId;
      by_category.auditItemCategoryName = c ? c.name : auditItemCategoryId;
      return by_category;
    });

    result.byCategory = grouped;

    return result;
  },
  [api.getters.getAuditProgress](state, getters) {
    const audit_items = getters.getAuditItems;

    const flat_audit_items = Object.values(audit_items);
    let count_audititems = flat_audit_items.length;

    const count_answered_auditems = flat_audit_items.reduce(
      (prev, audit_item) => {
        if (
          audit_item.deviations &&
          Object.keys(audit_item.deviations).length
        ) {
          return prev + 1;
        } else {
          return prev;
        }
      },
      0
    );

    let progress = Math.round(
      (100 * count_answered_auditems) / count_audititems
    );

    return {
      audititem_count: count_audititems,
      audititem_answered_count: count_answered_auditems,
      progress: progress
    };
  },
  [api.getters.getFlatExportData](state, getters, rootState, rootGetters) {
    return (auditItems, allowedFindingTypes) => {
      const findings_order = rootGetters["configuration/getFindingsOrder"];
      const measures_getter = rootGetters["audits/getMeasuresByAuditId"];
      const auditId = getters.getAuditId;

      const findingCustomFields = [
        "error_code",
        "module",
        "part",
        "zone",
        "costcenter"
      ];
      const CustomFieldsPrefix = "customFields";

      const extractCustomFindigFields = ((fields, prefix) => Finding => {
        const extractedCustomFields = {};
        findingCustomFields.forEach(fieldName => {
          const targetFieldName = _.camelCase([prefix, fieldName].join("_"));

          extractedCustomFields[targetFieldName] =
            fieldName in Finding ? Finding[fieldName] : "";
        });
        console.log(
          "extractCustomFindigFields",
          extractedCustomFields,
          Finding
        );
        return extractedCustomFields;
      })(findingCustomFields, CustomFieldsPrefix);

      const auditStandards =
        getters.getAuditDocumentData && getters.getAuditDocumentData.standard
          ? getters.getAuditDocumentData.standard
          : [];

      let auditCategories = _.filter(
        rootGetters["configuration/categories"],
        (v, i) => {
          return auditStandards.findIndex(s => s == i) >= 0;
        }
      );

      const categoryById = Id => {
        return auditCategories.reduce((p, c) => {
          if (p === null) {
            const cat = c.find(v => v.id == Id);
            if (cat) {
              return cat;
            }
          } else {
            return p;
          }
        }, null);
      };

      const importanceId2Order = Id => {
        return findings_order.findIndex(v => v == Id);
      };
      const active_audit = getters.getAuditDocumentData;
      const calcBase = getters.getAuditReportCalcSchema;
      const measures = measures_getter(auditId);
      let audit_items = active_audit.audit_items;
      if (auditItems) {
        audit_items = auditItems;
      }

      const measure_types_config = rootState.configuration.measure.data.types;

      const userGetter = rootGetters["users/getUser"];

      if (typeof audit_items === "undefined") {
        return [];
      } else {
        const export_rows = _.flatMap(
          audit_items,
          (audit_item, audit_item_key) => {
            audit_item.Weight = audit_item_weight(
              audit_item.question.importance,
              rootState
            );

            console.assert(
              typeof audit_item.id === "string",
              "expect key 'id' in ",
              audit_item
            );
            if (typeof audit_item.id !== "string") {
              audit_item.id = audit_item_key;
            }

            const flat_row = default_flat_export_row(
              audit_item,
              importanceId2Order(null),
              categoryById(audit_item.question.category)
            );
            flat_row.findingWeightBestPossible = calcBase.best_finding_value;
            flat_row.findingWeightWorstPossible = calcBase.worst_finding_value;

            if (audit_item.deviations) {
              return _.flatMap(
                audit_item.deviations,
                (finding, finding_key) => {
                  console.assert(
                    audit_item.id === audit_item_key,
                    "Expect audit_item id",
                    audit_item.id,
                    "to be",
                    audit_item_key,
                    "Item:",
                    audit_item
                  );
                  const finding_id = getFindingTypeId(finding);
                  const finding_order = importanceId2Order(finding_id);
                  const finding_type_config = calcBase.config_from_id(
                    finding_id
                  );

                  const finding_row = {
                    findingOrder: finding_order,
                    findingId: finding_key,
                    findingNote: finding.text,
                    findingWeight: parseInt(
                      getFallback(
                        finding_type_config.value,
                        calcBase.best_finding_value
                      ),
                      10
                    ),
                    findingTypeId: finding_id,
                    findingTypeName: getFallback(finding_type_config.text, ""),
                    findingTypeAbbr: getFallback(finding_type_config.short, ""),
                    findingTypeDesc: getFallback(
                      finding_type_config.description,
                      ""
                    ),
                    ...extractCustomFindigFields(finding)
                  };

                  const finding_measures = measures.filter(measure => {
                    return measure.deviation_id === finding_key;
                  });
                  const rows = [];

                  if (finding_measures.length > 0) {
                    for (const measure of finding_measures) {
                      const measure_row = normalize_measure_for_flat_export(
                        measure,
                        measure_types_config,
                        userGetter
                      );
                      rows.push({
                        ...flat_row,
                        ...finding_row,
                        ...measure_row
                      });
                    }
                  } else {
                    rows.push({
                      ...flat_row,
                      ...finding_row
                    });
                  }
                  return rows;
                }
              );
            } else {
              return [flat_row];
            }
          }
        );

        console.log("Export Rows", export_rows);

        if (allowedFindingTypes) {
          return export_rows.filter(row => {
            return allowedFindingTypes.includes(row.findingTypeId);
          });
        } else {
          return export_rows;
        }
      }
    };
  },
  [api.getters.getAuditStatistics](state, getters, rootState, rootGetters) {
    const audit = getters.getAuditDocumentData;
    if (audit === null) {
      return null;
    }

    const auditId = getters.getAuditId;

    const audit_findings = getters.getAuditFindingsFlat;
    const item_count = _.size(_.groupBy(audit_findings, "auditItemId"));
    const grouped = _.map(
      _.groupBy(audit_findings, "findingTypeAbbr"),
      (grouped_findings, key) => {
        return {
          // base: grouped_findings,
          abbr: key,
          name: grouped_findings[0].findingTypeName,
          count: grouped_findings.length,
          worst: _.reduce(
            grouped_findings,
            (sum, finding) => {
              return (
                sum +
                finding.auditItemWeight * finding.findingWeightWorstPossible
              );
            },
            0
          ),
          current: _.reduce(
            grouped_findings,
            (sum, finding) => {
              return sum + finding.auditItemWeight * finding.findingWeight;
            },
            0
          ),
          best: _.reduce(
            grouped_findings,
            (sum, finding) => {
              return (
                sum +
                finding.auditItemWeight * finding.findingWeightBestPossible
              );
            },
            0
          )
        };
      }
    );

    const findings_count = _.reduce(
      audit_findings,
      (sum, audit_finding) => {
        return sum + (audit_finding.findingId === null ? 0 : 1);
      },
      0
    );

    const measures_getter = rootGetters["audits/getMeasuresByAuditId"];
    const measures = measures_getter(auditId);

    const result = {
      auditItemCount: item_count,
      auditFindingsCount: findings_count,
      auditItemInvalidCount: null,
      auditMeasuresCount: _.size(measures),
      byMeasureType: null,
      byFindingType: grouped,
      statistics: {
        auditItemCount: {
          total: _.size(audit.audit_items),
          byType: auditItemCountByType(
            audit.audit_items,
            rootGetters["configuration/audititem"].data.importance
          )
        },
        auditFindingsCount: {
          total: findings_count,
          byType: auditFindingsCountByType(
            audit.audit_items,
            rootGetters["configuration/finding"].data.importance,
            rootGetters["configuration/getFindingsOrder"]
          )
        },
        auditMeasuresCount: {
          total: _.size(measures),
          byType: auditMeasuresCountByType(
            measures,
            rootGetters["configuration/measure"].data.types
          )
        }
      }
    };

    return result;
  },
  [api.getters.getAuditScore](state, getters) {
    const audit_findings = getters.getAuditFindingsFlat;
    const calcBase = getters.getAuditReportCalcSchema;
    const grouped_by_id = _.groupBy(audit_findings, "auditItemId");

    const defaultScore = () => {
      return {
        worst: 0,
        best: 0,
        current: 0
      };
    };

    const by_category = _.reduce(
      grouped_by_id,
      (sum, findings) => {
        const category = findings[0].auditItemCategory;
        const finding = findings[0];
        const currentValues = findings.map(v => {
          console.assert(
            v.auditItemCategory === category,
            "Expect category is equal for all",
            v,
            category
          );
          return v.findingWeight;
        });
        const appreciable_finding_value = calcBase.get_appreciable_finding_value(
          currentValues
        );

        if (!(category in sum)) {
          sum[category] = defaultScore();
          sum[category].name = category;
        }

        const auditItemWeight = finding.auditItemWeight;

        sum[category].worst +=
          auditItemWeight * finding.findingWeightWorstPossible;
        sum[category].best +=
          auditItemWeight * finding.findingWeightBestPossible;
        sum[category].current += auditItemWeight * appreciable_finding_value;

        return sum;
      },
      {}
    );

    const total_score = _.reduce(
      by_category,
      (sum, v) => {
        const score = {
          best: sum.best + v.best,
          worst: sum.worst + v.worst,
          current: sum.current + v.current
        };
        return score;
      },
      defaultScore()
    );

    return {
      inTotal: total_score,
      byCategory: _.map(by_category),
      customResult: getters[api.getters.customAuditResult]
    };
  },
  [api.getters.getAuditFindingsFlat](state, getters, rootState) {
    const audit_items = getters.getAuditItems;
    const calcBase = getters.getAuditReportCalcSchema;

    if (typeof audit_items === "undefined") {
      return [];
    } else {
      return _.flatMap(audit_items, (audit_item, audit_item_key) => {
        audit_item.Weight = audit_item_weight(
          audit_item.question.importance,
          rootState
        );

        if (audit_item.deviations) {
          return _.map(audit_item.deviations, (finding, finding_key) => {
            /*
              console.assert(
                audit_item.id === audit_item_key,
                "Expect audit_item id",
                audit_item.id,
                "to be",
                audit_item_key,
                "Item:",
                audit_item
              );
              */
            const finding_id = getFindingTypeId(finding);

            const finding_type_config = calcBase.config_from_id(finding_id);
            return {
              auditItemId: audit_item_key,
              auditItemCategory: audit_item.question.category,
              auditItemWeight: audit_item.Weight,
              auditItemText: audit_item.question.text,
              findingId: finding_key,
              findingNote: finding.text,
              findingWeight: parseInt(
                getFallback(
                  finding_type_config.value,
                  calcBase.best_finding_value
                ),
                10
              ),
              findingTypeId: finding_id,
              findingTypeName: getFallback(finding_type_config.text, ""),
              findingTypeAbbr: getFallback(finding_type_config.short, ""),
              findingTypeDesc: getFallback(finding_type_config.description, ""),
              findingWeightBestPossible: calcBase.best_finding_value,
              findingWeightWorstPossible: calcBase.worst_finding_value
            };
          });
        } else {
          return [
            {
              auditItemId: audit_item_key,
              auditItemCategory: audit_item.question.category,
              auditItemWeight: audit_item.Weight,
              auditItemText: audit_item.question.text,
              findingId: null,
              findingNote: null,
              findingWeight: null,
              findingTypeId: null,
              findingTypeName: null,
              findingTypeAbbr: null,
              findingTypeDesc: null,
              findingWeightBestPossible: calcBase.best_finding_value,
              findingWeightWorstPossible: calcBase.worst_finding_value
            }
          ];
        }
      });
    }
  },
  [api.getters.getFlatAuditScoreData](state, getters, rootState) {
    const calcBase = getters.getAuditReportCalcSchema;

    const audit_items_flat = Object.entries(getters.getAuditItems).map(
      ([auditItemId, auditItem]) => {
        const findings = Object.entries(auditItem.deviations || {}).map(
          ([findingId, finding]) => {
            const findingTypeId = getFindingTypeId(finding);
            const findingType = getFindingType(findingTypeId, rootState);
            const is_no_deviation = findingType
              ? findingType.is_no_deviation || false
              : false;
            const is_not_applicable = findingType
              ? findingType.is_not_applicable || false
              : false;
            return {
              findingId,
              findingTypeId,
              findingWeight: getFindingTypeWeight(findingType),
              is_no_deviation,
              is_not_applicable
            };
          }
        );

        const deviation_count = findings.reduce(
          (prev, finding) => prev + (finding.is_no_deviation ? 0 : 1),
          0
        );
        const is_not_applicable = findings.reduce(
          (prev, finding) => prev || finding.is_not_applicable,
          false
        );

        const appreciable_finding_value = calcBase.get_appreciable_finding_value(
          findings.map(finding => finding.findingWeight)
        );

        const auditItemWeight = audit_item_weight(
          auditItem.question.importance,
          rootState
        );
        return {
          auditItemId,
          auditItemTypeId: auditItem.question.importance,
          auditItemWeight,
          auditItemCategoryId:
            auditItem.question.category_id ||
            auditItem.question.category ||
            null,
          findings,
          findingsCount: findings.length,
          deviationCount: deviation_count,
          isNotApplicable: is_not_applicable,
          appreciableFindingValue: appreciable_finding_value,
          bestScore: auditItemWeight * calcBase.best_finding_value,
          worstScore: auditItemWeight * calcBase.worst_finding_value,
          currentScore: auditItemWeight * appreciable_finding_value
        };
      }
    );

    console.log("getFlatAuditScoreData", audit_items_flat);
    return audit_items_flat;
  },
  [api.getters.getAuditReportCalcSchema](
    state,
    getters,
    rootState,
    rootGetters
  ) {
    const active_audit = getters.getAuditDocumentData;
    if (active_audit === null) {
      return null;
    }
    const use_deviation = active_audit.reportSchema === "deviation";
    const calc_mapping_vals = _.keyBy(
      rootState.configuration.finding.data.importance,
      "id"
    );

    console.log("calc_mapping_vals", calc_mapping_vals);

    const findings_value_range =
      rootGetters["configuration/getWeightRanges"].finding;

    console.log("findings_value_range", findings_value_range);

    if (
      findings_value_range.min === Number.MAX_SAFE_INTEGER ||
      findings_value_range.max === Number.MIN_SAFE_INTEGER ||
      findings_value_range.min == findings_value_range.max
    ) {
      console.assert(
        findings_value_range.min === Number.MAX_SAFE_INTEGER ||
          findings_value_range.max === Number.MIN_SAFE_INTEGER,
        "No findings value range found, use default"
      );
      console.assert(
        findings_value_range.min == findings_value_range.max,
        "There is no range in the finding values, use default",
        findings_value_range
      );

      findings_value_range.min = 0;
      findings_value_range.max = 3;
    }

    console.log(
      "min",
      findings_value_range.min,
      "max",
      findings_value_range.max
    );

    return use_deviation
      ? calc_deviation(
          findings_value_range.min,
          findings_value_range.max,
          calc_mapping_vals
        )
      : calc_compliance(
          findings_value_range.min,
          findings_value_range.max,
          calc_mapping_vals
        );
  },

  [api.getters.getDefaultCalcSchemaName](state, getters, rootState) {
    return rootState.configuration.audit.reportSchema || "compliance";
  },
  [api.getters.isExistingDocument](state) {
    const Document = state.Document;
    return !Document || Document.exists;
  },
  [api.getters.hasPendingWrites](state) {
    const Document = state.Document;
    if (Document && Document.metadata) {
      return Document.metadata.hasPendingWrites;
    } else {
      return false;
    }
  },
  [api.getters.isCachedDocument](state) {
    const Document = state.Document;
    if (Document && Document.metadata) {
      return Document.metadata.fromCache;
    } else {
      return false;
    }
  },
  [api.getters.getDocumentOnlineState](state) {
    const Document = state.Document;
    if (Document && Document.metadata) {
      const { fromCache, hasPendingWrites } = Document.metadata;
      if (fromCache && hasPendingWrites) {
        return "unsync";
      } else if (!fromCache && hasPendingWrites) {
        return "unsaved";
      } else if (fromCache && !hasPendingWrites) {
        return "cached";
      } else {
        return "sync";
      }
    } else {
      return null;
    }
  },
  [api.getters.customAuditResult](state, getters, rootState, rootGetters) {
    const reportCustomResult =
      rootGetters["configuration/audit"].reportCustomResult || null;

    if (reportCustomResult === "qk") {
      ///// EXPERIMENTAL

      const customResult = CalcQkResult(
        getters[api.getters.getAuditFindingsFlat]
      );
      console.log("CustomResult", customResult);
      //////////////////////////////////////////////////////////////////
      return customResult;
    } else {
      return null;
    }
  }
};

const state = (() => ({
  [api.state.Document]: null,
  [api.state.Unlistener]: null,
  [api.state.MeasureDocuments]: {},
  [api.state.MeasureUnlistener]: null
}))();

export default {
  namespaced: true,
  api,
  state,
  actions,
  mutations,
  getters
};
